import React from "react"
import types from "prop-types"
import { adminSolutionPath } from "utils/routeHelpers"
import { MenuButton } from "@szhsin/react-menu"
import ExpandMenu, { ExpandMenuItem } from "shared/ExpandMenu"

const CategoryMenu = ({ category }) => {
  const { slug } = category

  return (
    <ExpandMenu
      expandMenuComponent={(
        <MenuButton className="circular-icon-button p-2.5" aria-label="show menu">
          <svg className="!w-4 !h-4" aria-hidden><use xlinkHref="#ellipsis" /></svg>
        </MenuButton>
      )}
    >
      <ExpandMenuItem href={adminSolutionPath(slug)}>
        Edit
      </ExpandMenuItem>
    </ExpandMenu>
  )
}

CategoryMenu.propTypes = {
  category: types.object.isRequired,
}

export default CategoryMenu
